<template>
  <el-card style="margin-bottom: 10px;" body-style="padding: 10px 20px 0 20px;">
    <el-row style="margin-bottom: 20px; background: white; border-radius: 15px;">
      <el-col :span="4">
        <!--<div style="width: 180px;">-->
        <router-link target="_blank" :to="{ name: 'ArticleDetail', params: { articleId: article.articleId } }">
          <!-- @click="viewDetail(article.articleId)" -->
          <div class="image">
            <!--无封面时使用随机图片 || 'https://picsum.photos/200?random='+article.articleId-->
            <el-image :src="baseUrl + article.img" lazy alt="随机图片">
              <div slot="error" class="image-slot">
                <!--<img src="@/assets/img/404.jpg" alt="" width="100%" height="100%">-->
                <!-- 无封面时使用随机图片 -->
                <img :src="'https://picsum.photos/200?random=' + article.articleId" alt="" width="100%" height="100%">
                <span class="tip">随机图片</span>
              </div>
            </el-image>
          </div>
        </router-link>

      </el-col>
      <el-col :span="20">
        <!-- style="cursor: pointer" @click="viewDetail(article.articleId)"-->
        <div>
          <router-link :to="{ name: 'ArticleDetail', params: { articleId: article.articleId } }">
            <h2>{{ article.title }}</h2>
            <p>{{ article.articleAbstract }}</p>
          </router-link>
        </div>

        <div class="base-info" style="color: #555;">
          <i class="el-icon-user-solid" style="font-size: 14px;"> {{ article.author }}</i>•
          <i class="el-icon-menu" style="font-size: 14px;"> {{ article.categoryName }}</i>•
          <i class="iconfont icon-date"> {{ article.updateTime }}</i>•
          <i class="iconfont icon-view"> {{ article.viewNum }}</i>•
          <i class="iconfont icon-dianzan"> {{ article.likeNum }}</i>
        </div>
        <div>
          <i class="iconfont icon-tags">
            <template v-for="(item, index) in article.tagsList">
              <el-tag :key="index" size="mini" effect="dark" :color="randomHexColors[index]"
                :style="{ 'margin-left': '10px', 'border-color': randomHexColors[index] }">
                {{ item.tagName }}
              </el-tag>
            </template>
          </i>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { getRandomCoolHexColor, getRandomWarmHexColor } from "@/utils/randomColor";
import config from "@/config/index"
import article from "@/store/modules/article";
export default {
  name: "ArticleItem",
  props: ['article'],
  data() {
    return {
      randomHexColor: null,
      randomHexColors: [],
      baseUrl: config.baseUrl.pro
    }
  },
  created() {
    this.getRandomHexColor()
  },
  methods: {
    getRandomHexColor() {
      for (let i = 0; i < this.article.tagsList.length; i++) {
        let color = getRandomCoolHexColor();
        // let color = getRandomWarmHexColor();
        this.randomHexColors.push(color)
      }
    },
    // 查看文章详情
    viewDetail(articleId) {
      this.$router.push({
        path: '/detail',
        query: {
          articleId
        }
      }).catch(() => { })
    }
  }
}
</script>

<style lang="less" scoped>
.article-item {
  //width: 50vw;
  width: 100%;
  margin-bottom: 20px;
}

.image {
  padding: 10px;
}

.image:hover {
  cursor: pointer;
}

p {
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.tip {
  display: block;
  width: 100%;
  font-size: 10px;
  color: #999;
  text-align: center;
}

a {
  color: black;
  text-decoration: none;
}
</style>
